"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseToken = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
require("../types");
const parseToken = (token) => {
    let tokenData = {
        username: '',
        role: '',
        permissions: [],
    };
    if (token) {
        const { unique_name: username, role, Policy: permissions = [] } = jwt_decode_1.default(token);
        tokenData = {
            username,
            role,
            permissions,
        };
    }
    return tokenData;
};
exports.parseToken = parseToken;
//# sourceMappingURL=parseToken.js.map